import { createActions } from 'redux-actions';

export const {
  getOrderForDocumentsById,
  getOrderForDocumentsByIdSuccess,
  getOrderForDocumentsByIdFailure,
} = createActions(
  'GET_ORDER_FOR_DOCUMENTS_BY_ID',
  'GET_ORDER_FOR_DOCUMENTS_BY_ID_SUCCESS',
  'GET_ORDER_FOR_DOCUMENTS_BY_ID_FAILURE'
);
